import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import { getHomepage } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

export default function MuseumsBrowse() {
  const settings = {
    dots: false,
    infinite: false,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authToken } = useSelector((state) => state?.Login);
  const { topUsers } = useSelector((state) => state?.home);

  const fetchUserId = (item_id) => {
    if (!authToken) {
      toastr.error("Please Login");
    } else {
      navigate(`/profile?id=${item_id}`);
    }
  };

  useEffect(() => {
    dispatch(getHomepage());
  }, []);

  return (
    <section className="Broswes-section">
      <Container>
        <div className="DigitalArtcollection-head currentauction-head">
          <h2>Browse By Museums</h2>
        </div>
        <div className="currenta-auction-slider">
          <Slider {...settings}>
            {topUsers &&
              topUsers?.length > 0 &&
              topUsers?.map((item, idx) => {
                return (
                  <div key={idx} className="digital-art-wrap browse-coming">
                    <div
                      onClick={() => fetchUserId(item?._id)}
                      className="currentlive-art-img position-relative"
                    >
                      {item?.profileImage?.link ? (
                        <img
                          src={item?.profileImage?.link}
                          alt=""
                          className="img-fluid  user-profile-image"
                        />
                      ) : (
                        <img
                          src="images/avatar.png"
                          alt=""
                          className="img-fluid user-profile-image"
                        />
                      )}
                    </div>
                    <div className="browse-card-content text-center">
                      <p>Name -{item?.username}</p>
                    </div>
                  </div>
                );
              })}
          </Slider>
        </div>
      </Container>
    </section>
  );
}
